"use client"

import React from 'react';
import {useAppStore} from "@/store/AppStore";
import styles from "./UserPathStatus.module.css";
import usePathStatus from "@/utils/hooks/usePathStatus";
import {Link} from "@/i18n/routing";

import {IoCaretForwardCircle} from "react-icons/io5";
import {useTranslations} from "use-intl";

export default function UserPathStatus(props: { id: number }) {
  const user = useAppStore((state) => state.user);
  const t = useTranslations("Main")
  const pathStatus = usePathStatus(user?.access_token, props.id);
  const total_distance = pathStatus?.total_distance
  //const instance = pathStatus?.instances?.at(0)
  return <div className={styles.container}>
    {pathStatus && (pathStatus?.actions?.length > 0) && <div className={styles.ctaActive}>
      <IoCaretForwardCircle className={styles.ctaIcon} size={20}/>
      {total_distance && <>{`${Math.floor(total_distance.total)}`} Km</>}
    </div>
    }
    {(!user || (pathStatus?.actions?.length == 0)) &&
        <Link href={`/walk`} className={styles.cta}><IoCaretForwardCircle size={20}/>{t('start_path')}</Link>}
  </div>
}
